<script setup lang="ts">
import './assets/style.scss'

withDefaults(
  defineProps<{
    title?: string
    content?: string
    width?: number | string
    height?: string
    /** Teleport dialog to body — prevents dropdown clipping inside nested layouts. */
    attach?: string | boolean | Element
  }>(),
  {
    width: 400,
    height: 'auto',
    attach: 'body',
  },
)

const show = defineModel<boolean>('show')
</script>

<template>
  <VDialog v-model="show" :max-width="width" :height="height" :attach="attach">
    <VCard>
      <VCardText>
        <div class="v-modal">
          <div class="v-modal__title">
            <slot name="title">
              {{ title }}
            </slot>
          </div>

          <div class="v-modal__content">
            <slot>
              {{ content }}
            </slot>
          </div>
        </div>
      </VCardText>
    </VCard>
  </VDialog>
</template>
